/**
 *
 * ClassListItem
 *
 */

import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// antd component
import { List } from 'antd';

function ClassListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('class-list-meta', className);
  const { t, i18n } = useTranslation();

  let incumbent = element?.incumbent?.description
      ? `${element?.incumbent?.description?.lastname} ${element?.incumbent?.description?.firstname}`
      : '';

  const studentAmountInfo = useMemo(
    () => {
      const length = `${element?.students?.length} ${i18n?.language == "de" ? t("labels.students") : t("labels.students")?.toLocaleLowerCase()}`;

      return (
        <span className="students-amount">
          {customHighlighter(length, searchString)}
        </span>
      );
    },
    [element?.students, i18n?.language, searchString],
  );
  
  return element && (
    <List.Item.Meta
      className={childClassNames}
      title={customHighlighter(element?.title, searchString)}
      description={
        <>
          {studentAmountInfo}
          {customHighlighter(incumbent, searchString)}
        </>
      }
    />
  );

};

ClassListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
ClassListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(ClassListItem);